module.exports = __webpack_public_path__ + "static/media/amazon.31aa9527.svg";